import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function WhatIncludes() {
  const ref = useScrollAnimation();
  // Colors for the books
  const primariaColors = ['bg-blue-500', 'bg-green-500', 'bg-orange-500', 'bg-purple-500', 'bg-gray-500', 'bg-red-500' // 6°
  ];
  const secundariaColors = ['bg-indigo-600', 'bg-emerald-600', 'bg-red-600', 'bg-violet-600', 'bg-slate-600', 'bg-amber-700' // 6°
  ];
  const primariaTomos = [{
    grade: '1°',
    title: 'Elementos del Arte',
    color: primariaColors[0]
  }, {
    grade: '2°',
    title: 'Técnicas Mixtas',
    color: primariaColors[1]
  }, {
    grade: '3°',
    title: 'Historias del Arte',
    color: primariaColors[2]
  }, {
    grade: '4°',
    title: 'Nuestra Identidad Artística',
    color: primariaColors[3]
  }, {
    grade: '5°',
    title: 'Arquitectos Creativos',
    color: primariaColors[4]
  }, {
    grade: '6°',
    title: 'Arte y Tecnología',
    color: primariaColors[5]
  }];
  const secundariaTomos = [{
    grade: '1°',
    title: 'Lenguajes Artísticos',
    color: secundariaColors[0]
  }, {
    grade: '2°',
    title: 'Producción Visual',
    color: secundariaColors[1]
  }, {
    grade: '3°',
    title: 'Arte Contemporáneo',
    color: secundariaColors[2]
  }, {
    grade: '4°',
    title: 'Proyectos de Muestra',
    color: secundariaColors[3]
  }, {
    grade: '5°',
    title: 'Análisis de Obras',
    color: secundariaColors[4]
  }, {
    grade: '6°',
    title: 'Arte Argentino',
    color: secundariaColors[5]
  }];
  return <section id="incluye" className="w-full bg-[#0d0d0d] py-24 px-4 border-t border-[#1a1a1a]" ref={ref} data-id="element-214">
      <div className="max-w-4xl mx-auto" data-id="element-215">
        {/* PART 1: VISUAL OVERVIEW */}
        <div className="scroll-hidden text-center mb-24" data-id="element-216">
          <div className="mb-8" data-id="element-217">
            <h2 className="text-3xl md:text-5xl font-black text-white mb-2 flex items-center justify-center gap-3" style={{
            fontFamily: 'Georgia, serif'
          }} data-id="element-218">
              <span data-id="element-219">🎨</span> PROFEPACK
            </h2>
            <h3 className="text-2xl md:text-4xl font-black text-[#F5C518]" style={{
            fontFamily: 'Georgia, serif'
          }} data-id="element-220">
              MEGAPACK ARTÍSTICA LISTA
            </h3>
          </div>

          <p className="text-lg md:text-xl text-white font-medium max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-221">
            12 tomos organizados por grado y año.
            <br className="hidden md:block" data-id="element-222" />
            240 clases con guion completo. 6 bonos estratégicos.
            <br className="hidden md:block" data-id="element-223" />
            Todo listo para usar desde hoy.
          </p>

          {/* Book Grid */}
          <div className="relative max-w-3xl mx-auto mb-12 px-2 md:px-0" data-id="element-224">
            <div className="grid grid-cols-6 gap-2 md:gap-4 mb-4" data-id="element-225">
              {/* Row 1: Primaria */}
              {primariaColors.map((color, i) => <div key={`pri-${i}`} className={`aspect-[3/4] rounded-lg md:rounded-xl border-2 border-[#F5C518] ${color} flex flex-col items-center justify-end pb-2 md:pb-4 relative overflow-hidden shadow-lg`} data-id="element-226">
                  <div className="absolute top-0 left-2 md:left-4 w-0.5 md:w-1 h-full bg-black/20" data-id="element-227"></div>
                  <span className="text-white font-black text-sm md:text-2xl drop-shadow-md" data-id="element-228">
                    {i + 1}°
                  </span>
                </div>)}

              {/* Row 2: Secundaria */}
              {secundariaColors.map((color, i) => <div key={`sec-${i}`} className={`aspect-[3/4] rounded-lg md:rounded-xl border-2 border-[#F5C518] ${color} flex flex-col items-center justify-end pb-2 md:pb-4 relative overflow-hidden shadow-lg`} data-id="element-229">
                  <div className="absolute top-0 left-2 md:left-4 w-0.5 md:w-1 h-full bg-black/20" data-id="element-230"></div>
                  <span className="text-white font-black text-sm md:text-2xl drop-shadow-md" data-id="element-231">
                    {i + 1}°
                  </span>
                </div>)}
            </div>

            {/* Badge */}
            <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 bg-[#F5C518] text-black px-6 py-2 rounded-full font-black text-sm md:text-base tracking-wider whitespace-nowrap shadow-[0_4px_14px_rgba(245,197,24,0.4)] z-10" data-id="element-232">
              12 TOMOS COMPLETOS
            </div>
          </div>

          {/* Feature Pills */}
          <div className="grid grid-cols-2 gap-4 max-w-2xl mx-auto mt-16" data-id="element-233">
            <div className="bg-[#141414] border border-[#F5C518]/30 rounded-full py-3 px-4 flex items-center justify-center gap-2" data-id="element-234">
              <span className="text-green-500" data-id="element-235">✅</span>
              <span className="text-white font-bold text-sm md:text-base" data-id="element-236">
                Por grado/año
              </span>
            </div>
            <div className="bg-[#141414] border border-[#F5C518]/30 rounded-full py-3 px-4 flex items-center justify-center gap-2" data-id="element-237">
              <span className="text-green-500" data-id="element-238">✅</span>
              <span className="text-white font-bold text-sm md:text-base" data-id="element-239">
                Con guion
              </span>
            </div>
            <div className="bg-[#141414] border border-[#F5C518]/30 rounded-full py-3 px-4 flex items-center justify-center gap-2" data-id="element-240">
              <span className="text-green-500" data-id="element-241">✅</span>
              <span className="text-white font-bold text-sm md:text-base" data-id="element-242">
                Con evaluación
              </span>
            </div>
            <div className="bg-[#141414] border border-[#F5C518]/30 rounded-full py-3 px-4 flex items-center justify-center gap-2" data-id="element-243">
              <span className="text-green-500" data-id="element-244">✅</span>
              <span className="text-white font-bold text-sm md:text-base" data-id="element-245">
                Con bonos
              </span>
            </div>
          </div>
        </div>

        {/* PART 2: DETAILED TOMO LIST */}
        <div className="scroll-hidden" data-id="element-246">
          <h2 className="text-4xl md:text-6xl font-black text-white text-center mb-12" style={{
          fontFamily: 'Georgia, serif'
        }} data-id="element-247">
            Lo que <span className="text-[#F5C518] italic" data-id="element-248">recibís</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-249">
            {/* Primaria Card */}
            <div className="bg-[#141414] border border-[#F5C518] rounded-2xl p-6 md:p-8" data-id="element-250">
              <h3 className="text-2xl md:text-3xl font-black text-[#F5C518] mb-2 flex items-center gap-3" data-id="element-251">
                <span data-id="element-252">📘</span> PRIMARIA — 6 Tomos
              </h3>
              <p className="text-gray-400 font-medium mb-8 pb-6 border-b border-[#2a2a2a]" data-id="element-253">
                Para docentes de Arte de 1° a 6° grado
              </p>

              <ul className="space-y-6" data-id="element-254">
                {primariaTomos.map((tomo, index) => <li key={index} className="flex items-start gap-4" data-id="element-255">
                    <div className={`w-6 h-8 rounded ${tomo.color} flex-shrink-0 mt-1 relative overflow-hidden border border-white/20`} data-id="element-256">
                      <div className="absolute top-0 left-1 w-0.5 h-full bg-black/20" data-id="element-257"></div>
                    </div>
                    <div data-id="element-258">
                      <p className="text-white text-lg" data-id="element-259">
                        <span className="font-bold" data-id="element-260">
                          Tomo {index + 1} — {tomo.grade} Grado:
                        </span>{' '}
                        {tomo.title}
                      </p>
                    </div>
                  </li>)}
              </ul>
            </div>

            {/* Secundaria Card */}
            <div className="bg-[#141414] border border-[#F5C518] rounded-2xl p-6 md:p-8" data-id="element-261">
              <h3 className="text-2xl md:text-3xl font-black text-[#F5C518] mb-2 flex items-center gap-3" data-id="element-262">
                <span data-id="element-263">📕</span> SECUNDARIA — 6 Tomos
              </h3>
              <p className="text-gray-400 font-medium mb-8 pb-6 border-b border-[#2a2a2a]" data-id="element-264">
                Para docentes de Arte de 1° a 6° año
              </p>

              <ul className="space-y-6" data-id="element-265">
                {secundariaTomos.map((tomo, index) => <li key={index} className="flex items-start gap-4" data-id="element-266">
                    <div className={`w-6 h-8 rounded ${tomo.color} flex-shrink-0 mt-1 relative overflow-hidden border border-white/20`} data-id="element-267">
                      <div className="absolute top-0 left-1 w-0.5 h-full bg-black/20" data-id="element-268"></div>
                    </div>
                    <div data-id="element-269">
                      <p className="text-white text-lg" data-id="element-270">
                        <span className="font-bold" data-id="element-271">
                          Tomo {index + 1} — {tomo.grade} Año:
                        </span>{' '}
                        {tomo.title}
                      </p>
                    </div>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}